import styled from '@emotion/styled';
import { Box, Typography } from '@mui/material';

export const Content = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.navy,
  padding: '8px',
  a: {
    color: theme.palette.primary.green,
    fontWeight: 700,
  },
  b: {
    fontWeight: 800,
  },
  li: {
    marginLeft: '32px',
  },
  ul: {
    marginTop: '8px',
  }
}));

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  boxSizing: 'border-box',
  flexDirection: 'column',
  marginLeft: 'auto',
  marginRight: 'auto',
  maxWidth: '1440px',
  padding: '40px',
}));
